"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitialDataLoad = void 0;
const react_1 = __importDefault(require("react"));
const merlin_hooks_1 = require("@travelnest/merlin-hooks");
const index_1 = require("../index");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../entities/fact/selectors");
const ValidationContext_1 = require("../context/ValidationContext");
const TaskCompletenessContext_1 = require("../context/TaskCompletenessContext");
const helpers_1 = require("../entities/fact/helpers");
const validation_1 = require("./validation");
const capability_1 = require("../util/capability");
const types_1 = require("../types");
const local_licence_1 = require("./validation/local-licence");
const notEmpty = (obj) => {
    return !!obj && !!Object.keys(obj).length;
};
const notEmptyArray = (arr) => {
    return !!arr && arr.length > 0;
};
const useInitialTerms = (enabled) => {
    const { dispatch: validationDispatch } = react_1.default.useContext(ValidationContext_1.ValidationContext);
    const { getState, dispatch } = (0, react_redux_1.useStore)();
    const { entityActions, customerId } = react_1.default.useContext(index_1.AppContext);
    react_1.default.useEffect(() => {
        if (!enabled) {
            validationDispatch(ValidationContext_1.validationActions.bypassTerms());
        }
    }, []);
    const tsAndCs = getState().data.termsContracts.byCustomerId[customerId];
    const tsAndCsLoading = !enabled ? false : (0, merlin_hooks_1.useDataLoad)(!tsAndCs, () => __awaiter(void 0, void 0, void 0, function* () { return yield dispatch(entityActions.termsContracts.getByCustomer(customerId)); }));
    react_1.default.useEffect(() => {
        if (enabled && !tsAndCsLoading) {
            validationDispatch(ValidationContext_1.validationActions.initialiseTerms(notEmptyArray(tsAndCs)));
        }
    }, [tsAndCsLoading]);
    return tsAndCsLoading;
};
const useInitialChannels = (enabled) => {
    const { dispatch: validationDispatch } = react_1.default.useContext(ValidationContext_1.ValidationContext);
    const { getState, dispatch } = (0, react_redux_1.useStore)();
    const { entityActions, customerId } = react_1.default.useContext(index_1.AppContext);
    react_1.default.useEffect(() => {
        if (!enabled) {
            validationDispatch(ValidationContext_1.validationActions.bypassChannels());
        }
    }, []);
    const marketingChannels = getState().data.listingContracts.byCustomerId[customerId];
    const channelsLoading = !enabled ? false : (0, merlin_hooks_1.useDataLoad)(!marketingChannels, () => __awaiter(void 0, void 0, void 0, function* () { return yield dispatch(entityActions.listingContracts.getByCustomer(customerId)); }));
    react_1.default.useEffect(() => {
        if (enabled && !channelsLoading) {
            validationDispatch(ValidationContext_1.validationActions.initialiseChannels(notEmptyArray(marketingChannels)));
        }
    }, [channelsLoading]);
    return channelsLoading;
};
function useInitialDataLoad() {
    const { entityActions, customerId, propertyId, capabilities } = react_1.default.useContext(index_1.AppContext);
    const { dispatch: validationDispatch } = react_1.default.useContext(ValidationContext_1.ValidationContext);
    const { dispatch: taskCompletenessDispatch } = react_1.default.useContext(TaskCompletenessContext_1.TaskCompletenessContext);
    const { getState, dispatch } = (0, react_redux_1.useStore)();
    const shouldLoadReviewFacts = (0, capability_1.hasCapability)(capabilities, types_1.DashboardCapabilities.RequireSectionReviews);
    const shouldLoadChannels = (0, capability_1.hasCapability)(capabilities, types_1.DashboardCapabilities.AllowChannelSelection);
    const shouldLoadTerms = (0, capability_1.hasCapability)(capabilities, types_1.DashboardCapabilities.RequireTermsAndConditions);
    const tsAndCsLoading = useInitialTerms(shouldLoadTerms);
    const channelsLoading = useInitialChannels(shouldLoadChannels);
    const propertySummary = getState().data.propertySummaries.byId[propertyId];
    const propertySummaryLoading = (0, merlin_hooks_1.useDataLoad)(!propertySummary, () => __awaiter(this, void 0, void 0, function* () { return yield dispatch(entityActions.propertySummary.getById(propertyId)); }));
    const property = getState().data.properties.byId[propertyId];
    const propertyLoading = (0, merlin_hooks_1.useDataLoad)(!property, () => __awaiter(this, void 0, void 0, function* () { return yield dispatch(entityActions.property.getById(propertyId)); }));
    const customer = getState().data.customers.byId[customerId];
    const customerLoading = (0, merlin_hooks_1.useDataLoad)(!customer, () => __awaiter(this, void 0, void 0, function* () { return yield dispatch(entityActions.customer.getById(customerId)); }));
    const propertyCompleteness = (0, selectors_1.propertyCompletenessFact)(getState(), propertyId);
    const propertyCompletenessLoading = !shouldLoadReviewFacts ? false : (0, merlin_hooks_1.useDataLoad)(!propertyCompleteness, () => __awaiter(this, void 0, void 0, function* () { return yield dispatch(entityActions.facts.getByProperty(propertyId)); }));
    const customerCompleteness = (0, selectors_1.customerCompletenessFact)(getState(), customerId);
    const customerCompletenessLoading = (0, merlin_hooks_1.useDataLoad)(!customerCompleteness, () => __awaiter(this, void 0, void 0, function* () { return yield dispatch(entityActions.facts.getByAccount(customerId)); }));
    const pricingValidation = getState().data.pricingValidation.byPropertyId[propertyId];
    const pricingValidationLoading = (0, merlin_hooks_1.useDataLoad)(!pricingValidation, () => __awaiter(this, void 0, void 0, function* () { return yield dispatch(entityActions.pricingValidation.getByPropertyId(propertyId)); }));
    const commission = getState().data.commission.byCustomer[customerId];
    const commissionLoading = (0, merlin_hooks_1.useDataLoad)(!commission, () => __awaiter(this, void 0, void 0, function* () { return yield dispatch(entityActions.commission.getByCustomer(customerId)); }));
    const commissionDeals = getState().data.commissionDeals.byCustomer[customerId];
    const commissionDealsLoading = (0, merlin_hooks_1.useDataLoad)(!commissionDeals, () => __awaiter(this, void 0, void 0, function* () { return yield dispatch(entityActions.commissionDeals.getDealsByCustomer(customerId)); }));
    const customerExperiments = getState().data.experiments.byCustomerId[customerId];
    const customerExperimentsLoading = (0, merlin_hooks_1.useDataLoad)(!customerExperiments && !!customerId, // If we are an admin, we may not have a customer ID
    () => __awaiter(this, void 0, void 0, function* () { return yield dispatch(entityActions.experiments.getByCustomerId(customerId)); }));
    const propertyExperiments = getState().data.experiments.byPropertyId[propertyId];
    const propertyExperimentsLoading = (0, merlin_hooks_1.useDataLoad)(!propertyExperiments, () => __awaiter(this, void 0, void 0, function* () { return yield dispatch(entityActions.experiments.getByPropertyId(propertyId)); }));
    const pricingType = getState().data.pricingType.byPropertyId[propertyId];
    const pricingTypeLoading = (0, merlin_hooks_1.useDataLoad)(!pricingType, () => __awaiter(this, void 0, void 0, function* () { return yield dispatch(entityActions.pricingType.getByPropertyId(propertyId)); }));
    const pricingOverrides = getState().data.pricingOverrides.byPropertyId[propertyId];
    const pricingOverridesLoading = (0, merlin_hooks_1.useDataLoad)(!pricingOverrides, () => __awaiter(this, void 0, void 0, function* () { return yield dispatch(entityActions.pricingOverrides.getByPropertyId(propertyId)); }));
    const pricingDefaults = getState().data.pricingDefaults.byPropertyId[propertyId];
    const pricingDefaultsLoading = (0, merlin_hooks_1.useDataLoad)(!pricingDefaults, () => __awaiter(this, void 0, void 0, function* () { return yield dispatch(entityActions.pricingDefaults.getByPropertyId(propertyId)); }));
    const itemTypes = getState().data.itemTypes;
    const itemTypesLoading = (0, merlin_hooks_1.useDataLoad)(!Object.keys(itemTypes).length, () => __awaiter(this, void 0, void 0, function* () { return yield dispatch(entityActions.itemTypes.getItemTypes()); }));
    react_1.default.useEffect(() => {
        const sendData = (data) => {
            taskCompletenessDispatch(TaskCompletenessContext_1.taskCompletenessActions.initialise(data, shouldLoadReviewFacts));
        };
        if (notEmpty(propertyCompleteness === null || propertyCompleteness === void 0 ? void 0 : propertyCompleteness.context) && notEmpty(customerCompleteness === null || customerCompleteness === void 0 ? void 0 : customerCompleteness.context)) {
            sendData((0, helpers_1.fromFactEntities)(propertyCompleteness, customerCompleteness));
        }
    }, [propertyCompletenessLoading, customerCompletenessLoading]);
    react_1.default.useEffect(() => {
        const sendData = (data) => validationDispatch(ValidationContext_1.validationActions.initialiseProperty(data));
        if (!propertySummaryLoading && notEmpty(propertySummary)) {
            sendData(propertySummary);
        }
    }, [propertySummaryLoading]);
    react_1.default.useEffect(() => {
        if (!customerLoading && customer) {
            // TODO: Refactor validators to accept multiple keys?
            if ((0, capability_1.hasCapability)(capabilities, types_1.DashboardCapabilities.RequirePersonalDetails)) {
                const name = (0, validation_1.getCustomerValidator)('name').fn(customer.name);
                const email = (0, validation_1.getCustomerValidator)('email').fn(customer.email);
                const phone = (0, validation_1.getCustomerValidator)('phone').fn(customer.phone);
                validationDispatch(ValidationContext_1.validationActions.initialiseCustomer(name, email, phone));
            }
            else {
                validationDispatch(ValidationContext_1.validationActions.bypassCustomer());
            }
        }
    }, [customerLoading]);
    react_1.default.useEffect(() => {
        if (!propertyLoading && property) {
            const licenceValidation = (0, local_licence_1.validateLocalLicence)(property);
            validationDispatch(ValidationContext_1.validationActions.initialiseLocalLicence(licenceValidation));
        }
    }, [propertyLoading]);
    const combinedLoadingState = customerCompletenessLoading ||
        propertyCompletenessLoading ||
        customerLoading ||
        propertyLoading ||
        propertySummaryLoading ||
        channelsLoading ||
        tsAndCsLoading ||
        pricingValidationLoading ||
        commissionLoading ||
        commissionDealsLoading ||
        customerExperimentsLoading ||
        propertyExperimentsLoading ||
        pricingTypeLoading ||
        pricingOverridesLoading ||
        pricingDefaultsLoading ||
        itemTypesLoading;
    return combinedLoadingState;
}
exports.useInitialDataLoad = useInitialDataLoad;
;
//# sourceMappingURL=useInitialDataLoad.js.map